<template>
  <v-list nav dense>
    <v-list-group active-class="white--text" v-for="(item,key) in items" :key="key">
      <template v-slot:activator>
        <v-list-item-title>{{item.groupTitle}}</v-list-item-title>
      </template>

      <v-list-item
        v-for="(val,k) in item.items"
        :key="k"
        link
        :to="val.route"
        active-class="white--text"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-content class="pl-4" v-on="on">
              <v-list-item-title v-text="val.title"></v-list-item-title>
            </v-list-item-content>
          </template>
          <span>{{val.title}}</span>
        </v-tooltip>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>
<script>
export default {
  data: () => ({
    doleItems: [
      {
        title: "Annual Medical Reports",
        route: "/dole/annual-med",
        isAuthorized: false,
        code: "ADD_USERS"
      },
      {
        title: "Annual Work Accident Illness Exposure Data",
        route: "/dole/annual-work-illness-exposure",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Employers Work Accident",
        route: "/dole/employer-work",
        isAuthorized: false,
        code: "UserUtly"
      },
      {
        title: "Roster of Workers",
        route: "/dole/roster",
        isAuthorized: false,
        code: "UserUtly"
      },
      {
        title: "Employment Information (ISLE)",
        route: "/dole/emp-info",
        isAuthorized: false,
        code: "UserUtly"
      }
    ],

    items: [
      {
        groupTitle: "DOLE Reports",
        items: [
          {
            title: "Annual Medical Reports",
            route: "/reports/annual-med",
            isAuthorized: false,
            code: "ADD_USERS"
          },
          {
            title: "Annual Work Accident Illness Exposure Data",
            route: "/reports/annual-work-illness-exposure",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Employers Work Accident",
            route: "/reports/employer-work",
            isAuthorized: false,
            code: "UserUtly"
          },
          {
            title: "Roster of Workers",
            route: "/reports/roster",
            isAuthorized: false,
            code: "UserUtly"
          },
          {
            title: "Employment Information (ISLE)",
            route: "/reports/emp-info",
            isAuthorized: false,
            code: "UserUtly"
          }
        ]
      },
      {
        groupTitle: "General Reports",
        items: [
          {
            title: "Account Number and Salary",
            route: "/reports/account-num-salary",
            isAuthorized: false,
            code: "ADD_USERS"
          },
          {
            title: "Benefit",
            route: "/reports/benefit",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Birthday of the Month",
            route: "/reports/birthday-month",
            isAuthorized: false,
            code: "UserUtly"
          },
          {
            title: "Certificate of Employement and Compensation",
            route: "/reports/coe-compensation",
            isAuthorized: false,
            code: "UserUtly"
          },
          {
            title:
              "Certificate of Employement with Job Description and History of Employment",
            route: "/dole/emp-info",
            isAuthorized: false,
            code: "UserUtly"
          },
          {
            title: "Certificate of Employment",
            route: "/reports/benefit",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Contract",
            route: "/reports/contract",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Employee Information",
            route: "/reports/employee-information",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Employee Masterfile Information",
            route: "/reports/emp-masterfile-info",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Employee Salary Report",
            route: "/reports/emp-salary",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Employee Seminar and Training Recommended",
            route: "/reports/emp-seminar-training",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Employmnet Slip",
            route: "/reports/employment-slip",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Extension of Contract",
            route: "/reports/extension-contract",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Identification Card",
            route: "/reports/id-card",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Insurance",
            route: "/reports/insurance",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "List of Employees Job Level Benefits",
            route: "/reports/job-level-benefits",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "List of Employees with Selected Fields",
            route: "/reports/with-selected-fields",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Manpower Management Report",
            route: "/reports/manpower-management",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Manpower Plantilla",
            route: "/reports/manpower-plantilla",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Memorandum",
            route: "/reports/memorandum",
            isAuthorized: false,
            code: "AuditTrail"
          },
          {
            title: "Notice to explain",
            route: "/reports/notice-to-explain",
            isAuthorized: false,
            code: "AuditTrail"
          }
        ]
      }
    ]
  })
};
</script>